import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBoltFill = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	height: 24,
	viewBox: "0 -960 960 960",
	width: 24,
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m320-80 40-280H160l360-520h80l-40 320h240L400-80h-80Z" })
});
export default SvgBoltFill;
